import React from "react";
import { useTheme, alpha, Box, Typography } from "@mui/material";

const ModernLoader = ({
  text = "Loading...",
  size = "medium",
  inline = false,
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const containerStyle = inline
    ? { display: "inline-flex", alignItems: "center", justifyContent: "center" }
    : {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: isDark
        ? alpha(theme.palette.background.default, 0.8)
        : "linear-gradient(135deg, #f8fbff 0%, #e2f1fe 100%)",
      backdropFilter: "blur(20px)",
      zIndex: 99999,
    };

  const loaderSize =
    size === "small" ? "4em" : size === "large" ? "6em" : "5em";

  return (
    <Box sx={containerStyle}>
      <div className="text-center">
        {/* Animated Loader */}
        <div
          className="loader"
          style={{
            position: "relative",
            width: loaderSize,
            height: loaderSize,
            transform: "rotate(165deg)",
            margin: "0 auto",
          }}
        />

        {/* Loading Text */}
        {!inline && (
          <Typography
            sx={{
              color: 'text.primary',
              fontSize: "16px",
              fontWeight: 900,
              marginTop: "32px",
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              opacity: 0.8
            }}
          >
            {text}
          </Typography>
        )}
      </div>

      <style>{`
        .loader:before,
        .loader:after {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          display: block;
          width: 0.5em;
          height: 0.5em;
          border-radius: 0.25em;
          transform: translate(-50%, -50%);
        }

        .loader:before {
          animation: before8 2s infinite;
        }

        .loader:after {
          animation: after6 2s infinite;
        }

        @keyframes before8 {
          0% {
            width: 0.5em;
            box-shadow: 1em -0.5em ${theme.palette.primary.main},
              -1em 0.5em ${alpha(theme.palette.primary.main, 0.4)};
          }
          35% {
            width: 2.5em;
            box-shadow: 0 -0.5em ${theme.palette.primary.main},
              0 0.5em ${alpha(theme.palette.primary.main, 0.4)};
          }
          70% {
            width: 0.5em;
            box-shadow: -1em -0.5em ${theme.palette.primary.main},
              1em 0.5em ${alpha(theme.palette.primary.main, 0.4)};
          }
          100% {
            box-shadow: 1em -0.5em ${theme.palette.primary.main},
              -1em 0.5em ${alpha(theme.palette.primary.main, 0.4)};
          }
        }

        @keyframes after6 {
          0% {
            height: 0.5em;
            box-shadow: 0.5em 1em ${alpha(theme.palette.primary.main, 0.6)},
              -0.5em -1em ${alpha(theme.palette.primary.main, 0.2)};
          }
          35% {
            height: 2.5em;
            box-shadow: 0.5em 0 ${alpha(theme.palette.primary.main, 0.6)},
              -0.5em 0 ${alpha(theme.palette.primary.main, 0.2)};
          }
          70% {
            height: 0.5em;
            box-shadow: 0.5em -1em ${alpha(theme.palette.primary.main, 0.6)},
              -0.5em 1em ${alpha(theme.palette.primary.main, 0.2)};
          }
          100% {
            box-shadow: 0.5em 1em ${alpha(theme.palette.primary.main, 0.6)},
              -0.5em -1em ${alpha(theme.palette.primary.main, 0.2)};
          }
        }
      `}</style>
    </Box>
  );
};

export default ModernLoader;
